import React, {useEffect, useRef, useState} from "react";
import {Form, Select, Tooltip} from "antd";
import {FaAngleDown} from "react-icons/fa";

interface SelectComponentProps {
  values: { value: any, item: string }[];
  initialFieldValue?:any;
  name?:string;
  label?:string;
  tooltip?:string;
  message?:string;
  required?:boolean;
  disabled?:boolean;
  onChange?(e:any):void
}

const SelectComponent = ({values, initialFieldValue, name, disabled, label, tooltip, message, required, onChange}: SelectComponentProps) => {
  const [focus, setFocus] = useState<"focused-datepicker" | undefined>(!!initialFieldValue ? "focused-datepicker" : undefined);
  const [value, setValue] = useState<any>(initialFieldValue);
  const inputRef = useRef<any>(null);
  const {Option} = Select;
  useEffect(() => {
    inputRef.current?.props.value && setFocus("focused-datepicker");
   setValue(inputRef.current?.props.value);

  }, [initialFieldValue, inputRef]);


  const items = () => {
    return values?.map((value, index) => {
      return (
        <Option value={value.value} key={`key_subject_${index}`}>{value.item}</Option>
      )
    })
  };

  const icon = <div>
    <FaAngleDown style={{color: "#4D4D4D", fontSize: 18, fontWeight: 700}}/>
  </div>;
  return (
    <div className={"select"}>
      <div className={`select-label ${focus}`} onClick={() => inputRef.current.focus()}>{label}</div>
      <Form.Item
        style={{width: "100%", display: "flex", justifyContent: "center"}}
        rules={[{required: required, message: message}]}
        name={name}>
        <Select style={{width: "100%"}}
                disabled={disabled}
                defaultValue={value}
                ref={inputRef}
                suffixIcon={!disabled && icon}
                onChange={(e)=>{setValue(e); onChange && onChange(e)}}
                onFocus={() => setFocus("focused-datepicker")}
                onBlur={() => !value && setFocus(undefined)}
        >
          {items()}
        </Select>
      </Form.Item>
      {tooltip && <Tooltip title={tooltip} placement="left"
               color={"#fff"} overlayStyle={{color: "#000"}}>
        <span className={"inputTooltip"}>?</span>
      </Tooltip>}
    </div>
  )
};

export default SelectComponent
